import { Table, Pagination, Button, Popconfirm, Form, Space, Tooltip, Tag } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import React, { useState } from "react";
import { DatePicker, Input, Row, Col } from "antd";
function DataTable(props) {
  console.log("props.columnsVisible.accounts", props.columnsVisible);
  const [boundFilter, setBoundFilter] = useState(null);
  const filteredData = boundFilter
    ? props.data.filter((record) => record.bound === boundFilter)
    : props.data;

  const columns = [
    {
      title: "#",
      key: "index",
      width: "20px",
      render: (text, record, index) =>
        (props.meta.page - 1) * props.meta.take + index + 1,
    },
    {
      title: "Payment ID",
      dataIndex: "id",
      key: "payment_id",
      render: (text, record) => (
        <strong>{`AWB-${String(record.id).padStart(5, "0")}`}</strong>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text, record, index) => (
        <span>{moment(record.date).format("DD-MM-YYYY")}</span>
      ),
    },
    {
      title: "Awb No",
      dataIndex: "awb_no",
      key: "awb_no",
      render: (text, record, index) => (
        <span>
          <b>{record?.awb?.awb_no}</b>
        </span>
      ),
    },
    {
      title: "Bound",
      dataIndex: "bound",
      key: "bound",
      filters: [
        { text: "Inbound", value: "inbound" },
        { text: "Outbound", value: "outbound" },
      ],
      filteredValue: boundFilter ? [boundFilter] : null,
      onFilter: (value, record) => record.bound === value,
      render: (text, record, index) => (
        <span>{record.bound === "inbound" ? "inbound" : "outbound"}</span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (text) => Number(text).toFixed(2),
    },
    {
      title: "Paid",
      key: "paid",
      align: "right",
      render: (_, record) => {
        const totalPaid = record.awbPaymentDetails?.reduce((sum, d) => sum + (Number(d.paidAmount) || 0), 0) || 0;
        return totalPaid.toFixed(2);
      },
    },
    {
      title: "Balance",
      key: "balance",
      align: "right",
      render: (_, record) => {
        const totalAmount = Number(record.amount) || 0;
        const totalPaid = record.awbPaymentDetails?.reduce((sum, d) => sum + (Number(d.paidAmount) || 0), 0) || 0;
        return (totalAmount - totalPaid).toFixed(2);
      },
    },
    {
      title: "Status",
      key: "status",
      align: "center",
      render: (_, record) => {
        const totalAmount = Number(record.amount) || 0;
        const totalPaid = record.awbPaymentDetails?.reduce((sum, d) => sum + (Number(d.paidAmount) || 0), 0) || 0;
        if (totalPaid >= totalAmount) return <Tag color="green">Paid</Tag>;
        if (totalPaid > 0) return <Tag color="orange">Partial</Tag>;
        return <Tag color="red">Unpaid</Tag>;
      },
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (text, record, index) => (
        <span>{record.user && record.user.name}</span>
      ),
    },
    {
      title: "Created",
      dataIndex: "createdat",
      key: "createdat",
      align: "center",
      render: (text, record, index) => (
        <span>
          <b>{record.created_user && record.created_user.name} </b>
          {moment(record.createdat).fromNow()}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_, record) => (
        <div style={{ display: "flex", gap: 4, flexWrap: "nowrap" }}>
          <Tooltip title="View">
            <Button
              size="small"
              icon={<EyeOutlined />}
              onClick={() => props.view(record)}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <Button
              size="small"
              type="primary"
              icon={<EditOutlined />}
              onClick={() => props.update(record)}
            />
          </Tooltip>
          <Popconfirm
            placement="bottomRight"
            title={"Are you sure to delete?"}
            okText="Yes"
            cancelText="No"
            onConfirm={() => props.delete(record)}
          >
            <Tooltip title="Delete">
              <Button size="small" danger icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];
  // Payment Details columns for expandable row
  const detailColumns = [
    {
      title: "#",
      key: "index",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Account",
      key: "account",
      width: "30%",
      render: (_, record) => {
        const accNo = record?.account_no || "-";
        const accName = record?.accounts?.account_name;
        return accName ? `${accNo} - ${accName}` : accNo;
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "25%",
      render: (text) => text || "-",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      width: "15%",
      align: "right",
      render: (v) => (v != null ? Number(v).toFixed(2) : "-"),
    },
    {
      title: "Paid",
      dataIndex: "paidAmount",
      key: "paidAmount",
      width: "15%",
      align: "right",
      render: (v) => (v != null ? Number(v).toFixed(2) : "0.00"),
    },
    {
      title: "Status",
      key: "isPaid",
      width: "10%",
      align: "center",
      render: (_, record) => {
        const amount = Number(record.amount) || 0;
        const paid = Number(record.paidAmount) || 0;
        if (paid >= amount) return <Tag color="green">Paid</Tag>;
        if (paid > 0) return <Tag color="orange">Partial</Tag>;
        return <Tag color="red">Unpaid</Tag>;
      },
    },
  ];

  // Expandable row render
  const expandedRowRender = (record) => {
    const details = record?.awbPaymentDetails || [];
    return (
      <div style={{ padding: "8px 16px", background: "#fafafa" }}>
        <Table
          columns={detailColumns}
          dataSource={details}
          pagination={false}
          size="small"
          rowKey="id"
          locale={{ emptyText: "No payment details" }}
        />
      </div>
    );
  };

  const onSearch = (values) => {
    const obj = {};
    const dateRange = values.dateRange;

    if (dateRange && dateRange.length === 2) {
      const [startDate, endDate] = dateRange;
      obj.date_from = startDate ? startDate.startOf("day").toISOString() : null;
      obj.date_to = endDate ? endDate.endOf("day").toISOString() : null;
    }

    if (values.search) {
      obj.awb_no = values.search.trim();
    }

    props.Search(obj);
  };
  return (
    <div style={{ minHeight: "60vh" }}>
      <Form onFinish={onSearch}>
        <Space align="center">
          <Form.Item label="Dates" name="dateRange">
            <DatePicker.RangePicker style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item label="search" name="search">
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
          </Form.Item>
        </Space>
      </Form>

      <Table
        columns={columns.filter((column) => column)}
        dataSource={filteredData}
        pagination={false}
        size="small"
        rowKey="id"
        expandable={{
          expandedRowRender,
          rowExpandable: (record) => record?.awbPaymentDetails?.length > 0,
        }}
      />
      <br />
      <div align="right">
        <Pagination
          defaultCurrent={props.meta && props.meta.page}
          total={props.meta && props.meta.itemCount}
          pageSize={props.meta && props.meta.take ? props.meta.take : 0}
          onChange={props.PageOnchange}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </div>
  );
}

export default DataTable;
